export const News = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="9" y="3" width="20" height="26" rx="1" stroke="currentColor" stroke-width="2"/>
<mask id="path-2-inside-1_1_6790" fill="white">
<rect x="12" y="6" width="14" height="9" rx="1"/>
</mask>
<rect x="12" y="6" width="14" height="9" rx="1" stroke="currentColor" stroke-width="4" mask="url(#path-2-inside-1_1_6790)"/>
<path d="M12 18H26" stroke="currentColor" stroke-width="2"/>
<path d="M12 22H20" stroke="currentColor" stroke-width="2"/>
<rect x="5" y="16" width="4" height="13" rx="2" stroke="currentColor" stroke-width="2"/>
<path d="M15 29H7" stroke="currentColor" stroke-width="2"/>
</svg>`;
